import styled from 'styled-components';

import colors from '@theme/colors';

export const FieldTextarea = styled.textarea`
  font-family: GTAmerica;
  width: 100%;
  height: auto;
  appearance: none;
  font-size: 0.875em;
  line-height: 1.5;
  letter-spacing: 0.5px;
  color: ${colors['charcoal']};
  background-color: ${colors['white']};
  box-shadow: none;
  border: ${({ error }) =>
    error ? `solid 2px ${colors['error-red']}` : 'none'};
  border-radius: 0px;
  padding: 22px 25px;

  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${colors['charcoal']};
    opacity: 0.54;
  }
  &::-ms-clear {
    width: 0;
    height: 0;
  }
`;
